<script setup lang="ts">
import UpArrow from '@/components/standardComponents/iconComponent/UpArrowIcon.vue';

const emits = defineEmits<{ click: [] }>();
</script>

<template>
    <div class="close_btn" @click="emits('click')">
        <div class="text">Close</div>
        <UpArrow class="icon" />
    </div>
</template>

<style lang="scss" scoped>
@use './CollapseBtn.scss';
</style>
